import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Users, Trash2, Pencil } from "lucide-react";
import AppHeader from "@/components/layout/AppHeader";
import { api } from "@/lib/api";
import PersonaFormDialog from "@/components/entities/PersonaFormDialog";

export default function PersonasPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const { data } = await api.get("/personas");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("¿Eliminar persona?")) return;
    await api.delete(`/personas/${id}`);
    toast.success("Persona eliminada");
    load();
  };

  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-heading font-extrabold text-slate-900">Personas</h1>
            <p className="text-slate-600 mt-1">Propietarios, compradores, inquilinos y empresas.</p>
          </div>
          <button onClick={() => { setEditing(null); setOpen(true); }} className="bm-btn-primary" data-testid="new-persona-btn">
            <Plus className="w-4 h-4" /> Nueva persona
          </button>
        </div>

        {items.length === 0 ? (
          <div className="bm-card p-10 text-center" data-testid="personas-empty">
            <Users className="w-10 h-10 mx-auto text-slate-300 mb-3" />
            <p className="text-slate-600">Aún no has registrado personas.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {items.map((p) => (
              <div key={p.id} className="bm-card p-4 flex items-center justify-between gap-3" data-testid={`persona-row-${p.id}`}>
                <div className="min-w-0">
                  <div className="font-heading font-bold text-slate-900 flex items-center gap-2">
                    {p.nombre || p.razon_social}
                    {p.rol === "asesor" && <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-[#E7EBF3] text-[#1E3A5F]" data-testid={`persona-badge-asesor-${p.id}`}>Asesor</span>}
                  </div>
                  <div className="text-xs text-slate-500">
                    {p.tipo === "moral" ? "Empresa" : (p.nacionalidad === "extranjera" ? "Extranjera" : "Mexicana")}
                    {p.rfc ? ` · RFC ${p.rfc}` : ""}
                    {p.correo ? ` · ${p.correo}` : ""}
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <button onClick={() => { setEditing(p); setOpen(true); }} className="p-2 text-slate-500 hover:text-[#2A5C55]" data-testid={`persona-edit-${p.id}`}>
                    <Pencil className="w-4 h-4" />
                  </button>
                  {p.rol !== "asesor" && (
                    <button onClick={() => del(p.id)} className="p-2 text-slate-400 hover:text-red-600" data-testid={`persona-delete-${p.id}`}>
                      <Trash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>

      <PersonaFormDialog open={open} onOpenChange={setOpen} initial={editing} onSaved={load} />
    </div>
  );
}
